import { ProjectPageContainer } from 'domains/projects/screens/ProjectPage';
import { ProjectsPageContainer } from 'domains/projects/screens/ProjectsPage';

import { projectsRoutesConfig } from '../../const';

const { useParams } = projectsRoutesConfig.project;

export const ProjectsParamsResolver = () => {
  const { projectId } = useParams();

  if (projectId) {
    return <ProjectPageContainer />;
  }

  return <ProjectsPageContainer />;
};
